import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { InstitutionServicesSummary } from './institution-services-summary.model';
import * as InstitutionServicesSummaryActions from './institution-services-summary.actions';

export const institutionServicesSummariesFeatureKey =
  'institutionsServicesSummary';

export interface State extends EntityState<InstitutionServicesSummary> {
  // additional entities state properties
  sumTotalServices: number;
  sumApprServices: number;
  sumDraftServices: number;
  sumRejectedServices: number;
  totalInst: number;
}

export const adapter: EntityAdapter<InstitutionServicesSummary> =
  createEntityAdapter<InstitutionServicesSummary>({
    selectId: (summary) => summary?.institution?.id,
  });

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  sumTotalServices: 0,
  sumApprServices: 0,
  sumDraftServices: 0,
  sumRejectedServices: 0,
  totalInst: 0
});

export const reducer = createReducer(
  initialState,
  on(
    InstitutionServicesSummaryActions.upsertInstitutionServicesSummary,
    (state, action) =>
      adapter.upsertOne(action.institutionServicesSummary, state)
  ),
  on(
    InstitutionServicesSummaryActions.upsertInstitutionsServicesSummary,
    (state, action) =>
      adapter.upsertMany(action.institutionsServicesSummary??[], {
        ...state,
        sumTotalServices: action.sumTotalServices,
        sumApprServices: action.sumApprServices,
        sumDraftServices: action.sumDraftServices,
        sumRejectedServices: action.sumRejectedServices,
        totalInst: action.totalInst
      })
  ),
  on(
    InstitutionServicesSummaryActions.loadInstitutionsServicesSummary,
    (state, action) => adapter.setAll(action.institutionServicesSummarys, state)
  ),
  on(
    InstitutionServicesSummaryActions.clearInstitutionsServicesSummary,
    (state) =>
      adapter.removeAll({
        ...state,
        sumTotalServices: 0,
        sumApprServices: 0,
        sumDraftServices: 0,
        sumRejectedServices: 0,
        totalInst: 0
      })
  )
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const sumOfInstitutionsServicesSummary = (state: State) => {
  return {
    sumTotalServices: state.sumTotalServices,
    sumApprServices: state.sumApprServices,
    sumDraftServices: state.sumDraftServices,
    sumRejectedServices: state.sumRejectedServices,
    totalInst: state.totalInst
  };
};
